export default "__VITE_ASSET__b7CTpVE7__"